export default {
  manage_cameraManagement_editCamera_title: "Edit Camera",
  manage_cameraManagement_editCamera_cameraUpdated: "The camera was updated successfully",
  manage_cameraManagement_editCamera_errorMessage: "An error occurred updating the camera",
  manage_cameraManagement_editCamera_label: "Label"
};
